import {
  Sheet,
  SheetContent,
  SheetTitle,
  SheetTrigger
} from '~/components/UI/shadcn/sheet'

import { useMediaQuery } from 'usehooks-ts'

const Options = ({
  children,
  selectedCount = 0
}: {
  children?: React.ReactNode
  selectedCount?: number
}) => {
  const isDesktop = useMediaQuery('(width >= 64rem)', {
    defaultValue: true,
    initializeWithValue: false
  })

  if (isDesktop) {
    return (
      <div className=''>
        <div className='pb-l flex items-center justify-between'>
          <img
            src='https://preview-websitemodern-uni-hull.cloud.contensis.com/site-elements/icons/duotone/ink-blue/mid-blue/sliders-2.svg'
            alt='Slider 2'
            className='w-m'
          />

          <p>
            {selectedCount === 0
              ? 'Filters'
              : `${selectedCount} filter${selectedCount === 1 ? '' : 's'} selected`}
          </p>
        </div>
        {children}
      </div>
    )
  }

  return (
    <Sheet>
      <SheetTrigger asChild>
        <div className='pb-l gap-xs flex max-w-[60px] flex-col items-center justify-between'>
          <img
            src='https://preview-websitemodern-uni-hull.cloud.contensis.com/site-elements/icons/duotone/ink-blue/mid-blue/sliders-2.svg'
            alt='Slider 2'
            className='w-m'
          />

          <p className='tag text-blue-m text-center'>Tap to edit</p>
        </div>
      </SheetTrigger>
      <SheetContent
        side='left'
        className='p-m top-auto h-[calc(100dvh-70px)] max-w-none overflow-y-auto bg-white sm:h-[calc(100dvh-90px)]'
      >
        <SheetTitle className='sr-only'>Filters</SheetTitle>
        {children}
      </SheetContent>
    </Sheet>
  )
}

export default Options
